import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useRouteMatch } from "react-router-dom";
import InfiniteScroll from 'react-infinite-scroll-component';
import parse from 'html-react-parser';
import { setPageClass, setUpHeader } from "../../../store/features/slice-ui";
import { renderMore} from "../../../store/features/slice-centres";
import PageHead from "../../../components/PageHead";
import PageContent from "../../../components/PageContent";
import CentresFilter from "../../../components/Filters/CentresFilter";
import CenterListItem from "../../../components/Cards/Cta";
import Section from "../../../components/Section";
import Loading from "../../../components/Loading";

const SelectCentre = () => {
  const dispatch = useDispatch();
  const centresIDs = useSelector((state) => state.centres.list['rp']);
  const centresListBasic = useSelector((state) => state.centres.basic);
  const currentLoaded = useSelector((state) => state.centres.currentLoaded['rp']);
  const match = useRouteMatch();
  useEffect(() => {
    dispatch(setPageClass("page-referbycentre-selectcentre"));
    dispatch(setUpHeader({
      show: true,
      back: true,
      profile: true,
      search: true
    }));
  }, [dispatch]);

  const rendeCentresItems = () => {
    return centresIDs && currentLoaded ? centresIDs.slice(0, currentLoaded).map(id => (
      <CenterListItem
          key={id}
          image={centresListBasic[id].image}
          title={parse(centresListBasic[id].title)}
          isCentered
          icon="chevron_right"
          link={`${match.url}/${id}`}
      />
    )) : null;
  }
  return (
    <>
      <PageHead 
        className="page-referbycentre-selectcentre--page-head"
        title="Refer a Patient"
        subtitle="By Centre"
      />
      <PageContent className="page-referbycentre-selectcentre--page-content">
        <Section className="split-content w-40-60">
          <CentresFilter className="page-referbycentre-selectcentre--filter" filter='rp' />
          <Section className="page-referbycentre-selectcentre--list attached-list">
            {centresIDs ? 
              <InfiniteScroll
                dataLength={currentLoaded}
                next={() => dispatch(renderMore('rp'))}
                hasMore={(currentLoaded < centresIDs.length)}
                loader={<Loading />}
                scrollThreshold={0.7}
              >
                {rendeCentresItems()}
              </InfiniteScroll>
            : null }
          </Section>
        </Section>
      </PageContent>
    </>
  );
};
export default SelectCentre;
